import type { BrokerListQuery } from '@/schemas/broker'

/**
 * Every licensed house: `BrokerScreen`'s and Reviews' own picker, their route
 * loaders' prefetch alongside the detail read (`BrokerScreen.loader.ts`), and
 * the Broker rail's Top rated block, which sorts the same list by rating — so
 * the three share one cache entry and one request. 100 is the largest page the
 * app's paging contract accepts and holds every house (77 on dev).
 *
 * A module constant so the key is stable: `useBrokerList` keys on the whole
 * query object, and rebuilding it per render would re-key the picker's list
 * on every keystroke in the stocks table's search field below it. Pinned to
 * `today` and to `name` for the same reason — the panel is a directory, not a
 * ranking, and it must not reshuffle when the page-level period changes.
 *
 * A `lib` module, not a component file: route loaders are not code-split, so
 * anything they import ships in the entry chunk, and a loader may not import a
 * component module at all — see docs/route-loading.md, "Steps" step 2. In
 * `features/brokers` (br:kit) since the rail, outside the screens, reads it too.
 */
export const BROKER_DIRECTORY_QUERY: BrokerListQuery = {
  page: 1,
  pageSize: 100,
  period: 'today',
  sort: 'name',
}
